angular.module('app').controller('CreditCtrl', function($mdDialog) {
    "ngInject";

    var main = this;

    main.save = function() {
        $mdDialog.hide(main.item);
    };
});
